module.exports = require("./pt-MZ.d.ts");